import { t2sManager } from '//www.ohmycream.com/cdn/shop/t/168/assets/t2s-scripts.js?v=2733939380948164481720599402';
export class T2sRecommendedProducts extends HTMLElement {
  connectedCallback() {
    this.recommendedSliderConfig = {
      accessibility: false,
      dots: true,
      arrows: true,
      prevArrow: "#custom-prev-arrow",
      nextArrow: "#custom-next-arrow",
      slidesToShow: 2,
      slidesToScroll: 2,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 560,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: false
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        }
      ]
    };

    this.similarSliderConfig = {
      accessibility: false,
      dots: true,
      arrows: true,
      prevArrow: "#custom-prev-arrow-2",
      nextArrow: "#custom-next-arrow-2",
      slidesToShow: 2,
      slidesToScroll: 2,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 560,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: false
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        }
      ]
    };

    /*this.customEventForSimilarProducts = {
      "data-custom-event": {
        "event":"clicCrossSellSimilarProduct",
        "event-parameter": {
          "productId": "product_id",
          "productName": "product_title",
          "position": "forloop_index"
        }
      },
      "data-gtm-list": "Product Cross-Sell Similar"
    };*/

    this.options1200_3 = {
      "pID": '1200',
      "zoneID": '1200-3',
      "sliderConfig": this.similarSliderConfig,
      //"gtmElements": this.customEventForSimilarProducts,
      "zoneSelector": '[data-recommend="1200"][data-zone="1200-3"]'
    };

    this.options1200_6 = {
      "pID": '1200',
      "zoneID": '1200-6',
      "sliderConfig": this.recommendedSliderConfig,
      "zoneSelector": '[data-recommend="1200"][data-zone="1200-6"]'
    };

    this.zone = {
      "pID": "1200",
      "1200-6": this.options1200_6,
      "1200-3": this.options1200_3
    };

    t2sManager._getRecommendedProducts(this.zone);
  }
}

try {
  window.customElements.define('t2s-recommended-products', T2sRecommendedProducts);
} catch (e) { }